/**
 * Cache Buster - refreshes stale bundles/SW caches without logging users out.
 * Increment CACHE_VERSION to trigger a reset for all users on next visit.
 */
const CACHE_VERSION = "2026-10-22-card-payment";
const CACHE_KEY = "app_cache_version";
const RESET_FLAG = "app_cache_reset_in_progress";

function clearAllCookies() {
  try {
    const host = window.location.hostname;
    const parts = host.split(".");
    const domains = [""];
    for (let i = 0; i < parts.length - 1; i++) {
      const d = parts.slice(i).join(".");
      domains.push(`; domain=${d}`, `; domain=.${d}`);
    }
    const segs = window.location.pathname.split("/").filter(Boolean);
    const paths = ["/"];
    segs.forEach((_, i) => paths.push("/" + segs.slice(0, i + 1).join("/")));
    document.cookie.split(";").forEach((c) => {
      const name = c.split("=")[0].trim();
      if (!name) return;
      domains.forEach((dom) =>
        paths.forEach((p) => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}${dom}`;
        }),
      );
    });
  } catch {
    /* ignore */
  }
}

async function performClientCacheRefresh() {
  clearAllCookies();
  try {
    const keep = sessionStorage.getItem(RESET_FLAG);
    sessionStorage.clear();
    if (keep) sessionStorage.setItem(RESET_FLAG, keep);
  } catch {
    /* ignore */
  }


  try {
    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } catch {
    /* ignore */
  }

  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch {
    /* ignore */
  }

  localStorage.setItem(CACHE_KEY, CACHE_VERSION);
  sessionStorage.removeItem(RESET_FLAG);
  window.location.reload();
}

export function runCacheBuster() {
  const stored = localStorage.getItem(CACHE_KEY);
  const inProgress = sessionStorage.getItem(RESET_FLAG);

  if (stored === CACHE_VERSION || inProgress === CACHE_VERSION) return;

  sessionStorage.setItem(RESET_FLAG, CACHE_VERSION);
  void performClientCacheRefresh();
}
